import Vue from 'vue'

import Offset from '../components/helper/Offset'
import Card from '../components/material/Card'
import ChartCard from '../components/material/ChartCard'
import Notification from '../components/material/Notification'
import StatsCard from '../components/material/StatsCard'

import PopupDialog from '../components/popupDialog'
import AlertDialog from '../components/alertDialog'
import Snackbar from '../components/snackbar'
import OrgList from '../components/OrgList'
import TreeItem from '../components/tree-item'
import AdFormat from '../components/AdFormat'

import BarChart from '../components/analytics/BarChart'
import LineChart from '../components/analytics/LineChart'

import Multiselect from 'vue-multiselect'
import OrganizationSelector from '../components/form/OrganizationSelector/OrganizationSelector'
import OrganizationsSelector from '../components/form/OrganizationsSelector/OrganizationsSelector'
import CountrySelector from '../components/form/CountrySelector/CountrySelector'
import FormatSelector from '../components/form/FormatSelector/FormatSelector'
import CampaignBannerSelector from '../components/form/CampaignBannerSelector/CampaignBannerSelector'
import FormatBannerSelector from '../components/form/FormatBannerSelector/FormatBannerSelector'
import CodeInput from '../components/form/CodeInput/CodeInput'
import FormatParameterTypeSelector from '../components/form/FormatParameterTypeSelector/FormatParameterTypeSelector'
import CampaignParametersForm from '../components/form/CampaignParametersForm/CampaignParametersForm'
import CampaignCanvasBannerPlaceholdersForm from '../components/form/CampaignCanvasBannerPlaceholdersForm/CampaignCanvasBannerPlaceholdersForm'
import CampaignParametersText from '../components/form/CampaignParametersFormTextType/CampaignParametersFormTextType'
import CampaignParametersInsTag from '../components/form/CampaignParametersFormInsTagType/CampaignParametersFormInsTagType'

import FormSection from '../components/grid/FormSection'
import FormInput from '../components/grid/FormInput'

import FormatParametersEditor from '../components/form/FormatParametersEditor/FormatParametersEditor'
import FormatBuiltInParametersEditor from '../components/form/FormatParametersEditor/FormatBuiltInParametersEditor'
import CanvasBannerPlaceholderEditor from '../components/form/CanvasBannerPlaceholderEditor/CanvasBannerPlaceholderEditor'

import UpgradeFormatVersion from '../components/UpgradeFormatVersion/UpgradeFormatVersion'

import CampaignParametersFormImageType from '../components/form/CampaignParametersFormImageType/CampaignParametersFormImageType';
import CampaignParametersFormVideoType from '../components/form/CampaignParametersFormVideoType/CampaignParametersFormVideoType';
import CampaignParametersFormSeenThisType from '../components/form/CampaignParametersFormSeenThisType/CampaignParametersFormSeenThisType';
import CampaignParametersFormChoiceType from '../components/form/CampaignParametersFormChoiceType/CampaignParametersFormChoiceType';
import CampaignCanvasContentForm from '../components/form/CampaignCanvasContentForm/CampaignCanvasContentForm';

import FormatParametersFormTextType from '../components/form/FormatParametersFormTypes/FormatParametersFormTextType';
import FormatParametersFormTextAreaType from '../components/form/FormatParametersFormTypes/FormatParametersFormTextAreaType';
import FormatParametersFormImageType from '../components/form/FormatParametersFormTypes/FormatParametersFormImageType';
import FormatParametersFormVideoType from '../components/form/FormatParametersFormTypes/FormatParametersFormVideoType';
import FormatParametersFormChoiceType from '../components/form/FormatParametersFormTypes/FormatParametersFormChoiceType';
import FormatParametersFormSeenThisType from '../components/form/FormatParametersFormTypes/FormatParametersFormSeenThisType'
import FormatParametersFormFeedKeyType from '../components/form/FormatParametersFormTypes/FormatParametersFormFeedKeyType'

import ThirdPartyTrackersEditor from '../components/form/ThirdPartyTrackersEditor/ThirdPartyTrackersEditor';

Vue.component(Offset.name, Offset)
Vue.component(Card.name, Card)
Vue.component(ChartCard.name, ChartCard)
Vue.component(Notification.name, Notification)
Vue.component(StatsCard.name, StatsCard)

Vue.component('popupDialog', PopupDialog)
Vue.component('alertDialog', AlertDialog)
Vue.component('snackbar', Snackbar)
Vue.component('org-list', OrgList)
Vue.component('tree-item', TreeItem)
Vue.component('ad-format', AdFormat)
Vue.component('organization-selector', OrganizationSelector)
Vue.component('organizations-selector', OrganizationsSelector)
Vue.component('country-selector', CountrySelector)
Vue.component('format-selector', FormatSelector)
Vue.component('campaign-banner-selector', CampaignBannerSelector)
Vue.component('format-banner-selector', FormatBannerSelector)
Vue.component('code-input', CodeInput)
Vue.component('format-parameter-type-selector', FormatParameterTypeSelector)

Vue.component('form-section', FormSection)
Vue.component('form-input', FormInput)

Vue.component('BarChart', BarChart);
Vue.component('LineChart', LineChart);

Vue.component('multiselect', Multiselect)

Vue.component('format-parameters-editor', FormatParametersEditor);
Vue.component('format-builtin-parameters-editor', FormatBuiltInParametersEditor);
Vue.component('canvas-banner-placeholder-editor', CanvasBannerPlaceholderEditor);
Vue.component('campaign-parameters-form', CampaignParametersForm);
Vue.component('campaign-canvas-banner-placeholder-form', CampaignCanvasBannerPlaceholdersForm);
Vue.component('campaign-parameters-text', CampaignParametersText);
Vue.component('campaign-parameters-instag', CampaignParametersInsTag);
Vue.component('campaign-parameters-image', CampaignParametersFormImageType);
Vue.component('campaign-parameters-video', CampaignParametersFormVideoType);
Vue.component('campaign-parameters-seenthis', CampaignParametersFormSeenThisType)
Vue.component('campaign-parameters-choice', CampaignParametersFormChoiceType);

Vue.component('format-parameters-text', FormatParametersFormTextType);
Vue.component('format-parameters-textarea', FormatParametersFormTextAreaType);
Vue.component('format-parameters-image', FormatParametersFormImageType);
Vue.component('format-parameters-video', FormatParametersFormVideoType);
Vue.component('format-parameters-seenthis', FormatParametersFormSeenThisType);
Vue.component('format-parameters-choice', FormatParametersFormChoiceType);
Vue.component('format-parameters-feed-key', FormatParametersFormFeedKeyType);
Vue.component('campaign-canvas-content-form', CampaignCanvasContentForm);

Vue.component('upgrade-formatversion', UpgradeFormatVersion);


Vue.component('thirdpartytrackers-editor', ThirdPartyTrackersEditor);
